import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide notes="Basic explanation of what ChatGPT is" transition="fade" networkBackground="full">
      <div
        className="relative z-10 flex flex-col 
      justify-center h-full px-24 py-8 text-left font-light slide-scale-80"
      >
        <h2 className="title">Wat is ChatGPT</h2>

        <div className="space-y-6">
          <p>• Generative Pre-trained Transformer</p>
          <p>• Een geavanceerd AI taalmodel van OpenAI</p>
          <p>• Getraind op grote hoeveelheden internet tekst</p>
          <p>• Gefinetuned met human feedback (RLHF)</p>
          <p>• Gefinetuned voor conversatie</p>
          <p>• Een absoluut powerhouse</p>
        </div>
      </div>
    </Slide>
  );
};
